<template>
  <div>
    <div class="home-head home-head-page">
      <TopHeader></TopHeader>
    </div>
    <div class="case case1 caseContain">
      <div class="caseTitle">
        <div class="container">
          <h3>应用案例</h3>
          <ul>
            <li class="caBg1 active">
              <a @click="gotoCase1" herf="#">
                <span>
                  <em>IDC服务商</em>
                  <i>IDC机房运维分析监控</i>
                </span>
              </a>
            </li>
            <li class="caBg2">
              <a @click="gotoCase2" herf="#">
                <span>
                  <em>
                    某上市
                    <b class="pSec"></b>零售企业
                  </em>
                  <i>
                    全业务可视化
                    <b class="pSec"></b>统计分析
                  </i>
                </span>
              </a>
            </li>
            <li class="caBg6">
              <a @click="gotoCase3_1" herf="#">
                <span>
                  <em>
                    某交通管理部门
                    <b class="pSec"></b>
                  </em>
                  <i>交通流量业务可视化统计分析</i>
                </span>
              </a>
            </li>
            <li class="caBg3">
              <a @click="gotoCase4" herf="#">
                <span>
                  <em>运营商</em>
                  <i>
                    用户标签可视化
                    <b class="pSec"></b>聚合分析
                  </i>
                </span>
              </a>
            </li>
            <li class="caBg4">
              <a @click="gotoCase3_2" herf="#">
                <span>
                  <em>某海事局</em>
                  <i>船舶追越分析</i>
                </span>
              </a>
            </li>
            <li class="caBg5">
              <a @click="gotoCase3_3" herf="#">
                <span>
                  <em>
                    智能电网
                    <b class="pSec"></b>运检
                  </em>
                  <i>
                    -大数据设备画
                    <b class="pSec"></b>像及应用
                  </i>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="caseDetail">
        <div class="container">
          <div class="caseDetailS">
            <span class="caseImg">
              <span></span>
              <em>IDC服务商</em>
              <i>-IDC机房运维分析监控</i>
              <b></b>
            </span>
            <div class="caseCon">
              <div class="cPage1">
                <h4>项目背景</h4>
                <p>
                  某网络公司是位居国内前列数据中心（IDC）服务提供商，在运维过程中，往往面临日志存储相对零
                  <i class="pSec"></i>散、无法多维度查询、不能及时进行日志分析和告警的问题，给日常运维工作带来极大挑战。
                </p>
                <p>
                  “柚数据”平台可以很好帮助企业解决这些问题，成为企业日常维护工具，提高运维效率。也可为有
                  <i class="pSec"></i>数据服务需求的用户提供增值服务，提升企业的核心竞争力。
                </p>
              </div>
              <div class="cPage2">
                <h4>需求理解</h4>
                <h5>从背景上来看，该用户的需求分为以下几个方面：</h5>
                <ol type="1">
                  <li>各个机房之间大量日志数据需集中采集，统一管理，准实时索引源的整合;</li>
                  <li>提供搜索、分析、可视化和监控告警等功能;</li>
                  <li>帮助客户进行线上业务实时监控、业务异常原因定位、业务日志数据统计分析、及安全与合规审计;</li>
                  <li>定制客户需求，灵活呈现，提供开放 API 接口，灵活对接第三方系统或二次开发日志应用。</li>
                </ol>
              </div>
              <div class="cPage3">
                <h4>目标与价值</h4>
                <table>
                  <thead>
                    <tr>
                      <th>目标</th>
                      <th>价值</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          <i class="K56"></i>升级现有日志处理结构
                        </p>
                      </td>
                      <td>
                        <p>
                          满足现有和不断扩容的节点对自身统计的需要, 确保日
                          <i class="pSec"></i>志的完整性和实时性。
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <i class="K56"></i>向最终用户输出全量的日志可视
                          <i class="pSec"></i>化呈现及分析服务
                        </p>
                      </td>
                      <td>
                        <p>
                          具备SAAS 化的日志搜索、统计、可视化以及自定义告
                          <i class="pSec"></i>警的能力。
                          <i class="pSec"></i>为用户提供各种数据呈现（涵盖HTTP流量透视、流量
                          <i class="pSec"></i>全景图、DNS全景图、交换机日志、SSH登录事件、
                          <i class="pSec"></i>SIP通话分析、SMTP邮件发送，FTP文件传输，RDP远
                          <i class="pSec"></i>程桌面等)
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <i class="K56"></i>个性化服务
                        </p>
                      </td>
                      <td>
                        <p>
                          可为不同用户定制不同的私有云大数据服务，灵活的
                          <i class="pSec"></i>可视化呈现。
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<style scoped>
.case {
  color: #000000;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
</style>

<script>
import TopHeader from "../../../common/compoments/TopHeader";
import Footer from "../components/Footer.vue";
export default {
  name: "case1",
  components: {
    TopHeader,
    Footer
  },
  data() {
    return {};
  },
  created: function() {},
  mounted: function() {
    this.$nextTick().then(
      function() {
        var loginR = document
          .getElementsByClassName("right-selection")[0]
          .getElementsByTagName("div");
        loginR[0].className = "new_login new_login_bcon3";
        loginR[1].className = "new_login new_login_bcon4";
      }.bind(this)
    );
  },
  methods: {
    gotoAbout: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "about" });
    },
    gotoScenarios: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "scenarios" });
    },
    gotoCase1: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case1" });
    },
    gotoCase2: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case2" });
    },
    gotoCase3_1: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case3_1" });
    },
    gotoCase3_2: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case3_2" });
    },
    gotoCase3_3: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case3_3" });
    },
    gotoCase4: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case4" });
    }
  }
};
</script>
